/**
 * @generated SignedSource<<97f20270c027280b56000d08395b1df7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedStorefrontLink_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sellerBrandingHelpers_user">;
  readonly " $fragmentType": "SbSharedStorefrontLink_user";
};
export type SbSharedStorefrontLink_user$key = {
  readonly " $data"?: SbSharedStorefrontLink_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedStorefrontLink_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedStorefrontLink_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sellerBrandingHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f89cee0c3e61a7567379941aa0f9d0c0";

export default node;
